<template>
  <vx-card class="donut-chart-card" style="overflow-x: auto; max-width: 100%;">
    <vs-row>
      <vs-col style="position: relative">
        <div class="flex flex-col justify-between">
          <div class="w-full flex mt-6 flex-col" style="">
            <div v-for="index in 5" class="flex flex-col" style="margin-top: 25px;" :key="index">
              <div class="flex w-full justify-between" style="">
                <div>{{ realValue[index - 1] ? realValue[index - 1].label : '' }}</div>
                <div>{{ realValue[index - 1] ? Math.floor(realValue[index - 1].value*100)/100 : '' }} {{ realValue[index - 1] ? unit : '&nbsp;' }}</div>
              </div>
              <div class="relative w-full" style="background-color:#F2F2F2; height: 7px; margin-top: 7px;" :style="{visibility: realValue[index - 1] ? 'visible': 'hidden'}">
                <div class="absolute h-full" :style="{backgroundColor: dataGroup.colors[index - 1], width: `${realValue[index - 1] ? (realValue[index - 1].value > 100 ? 100: realValue[index - 1].value) : '0'}%`}"></div>
              </div>
            </div>
          </div>

          <div class="flex flex-col" style="margin-top: 58px;">
            <div class="my-2" style="height:1px; background-color: #E6E9F4;"></div>

            <donut-chart-label v-if="realValue.length === 0" :label="'데이터 없음'" :value="``" color="#535767" />
            <donut-chart-label v-else label="전체 집행률" :unit="unit" :value="isNaN(sumCount) ? '-' : `${sumCount}`" color="#535767" />
          </div>
        </div>

        <!-- header tools -->
        <div class="donut-chart-card-header">
          <span class="font-bold" style="font-size: 1em; align-self: center"><i class="dot"></i>{{ title }}</span>
          <div style="justify-content: end">
            <vs-select v-model="selectedYear" class="w-24" @change="loadData">
              <vs-select-item v-for="option of yearOptions" :key="option.value" :value="option.value" :text="option.label" />
            </vs-select>
          </div>
        </div>
      </vs-col>
    </vs-row>

  </vx-card>
</template>

<script>
import DonutChartLabel from '@/popup/DonutChartLabel.vue'
export default {
  name: 'DonutChart308',
  components: {DonutChartLabel},
  props: {
    title: {
      type: String,
      default: '안전보건 예산 집행률 현황'
    },
    unit: {
      type: String,
      default: '%'
    },
    value: {
      type: Array,
      default: () => [{label: '데이터 없음', value: 0}]
    },
    isMoveDetail: {
      type: Boolean,
      default: true
    },
    isMoveWrite: Boolean
  },
  data() {
    return {
      selectedYear: new Date().getFullYear(),
      chartData: [],
      sumCount: 0,
    }
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id
    },
    myLv() {
      return this.$store.state.auth.userInfo.position
    },
    /**
     * 최근 5년부터 내년까지 옵션
     */
    yearOptions() {
      const currentYear = new Date().getFullYear()
      const startYear = currentYear - 5
      const options = []
      for (let i = 0; i < 7; i++) {
        options.push({label: `${startYear + i}년`, value: startYear + i})
      }

      return options.reverse()
    },

    realValue() {
      const maxLength = 5

      if (this.chartData.length) {
        const value = JSON.parse(JSON.stringify(this.chartData))
        if (value.length > maxLength) {
          return value.slice(0, maxLength)
        }
        return value
      } else {
        return [{label: '데이터 없음', value: 0}]
      }
    },

    dataGroup() {
      const labels = []
      const colors = ['#0058FF', '#F99600', '#FFC700', '#21D59B', '#F0142F']
      const values = []

      this.realValue.map(value => {
        if (value.label) labels.push(value.label)
        if (value.value || value.value === 0) {
          values.push(value.value)
        }
      })

      return {labels, colors, values}
    },
  },

  mounted() {
    this.loadData()
  },

  methods: {
    onClickDetail() {
      this.$emit('detail')
    },
    onClickWrite() {
      this.$emit('write')
    },
    onClickItem(data) {
      this.$emit('item', data)
    },
    async loadData() {
      const projectId = this.projectId;
      const boardId = 789;
      const page = 1;
      const perPage = 1000;

      const conditions = []
      conditions.push({key: 'header.year', operator: '=', value: this.selectedYear})

      const response = await this.$store.dispatch("board/LOAD_POST_LIST", {
        projectId,
        boardId,
        page,
        perPage,
        conditions,
        withMeta: true,
        metaKeys: ['body.total.%'],
        onlyMeta: true,
      });

      const allData = response.data || [];

      const countData = {};
      let 총총예산 = 0;
      let 총집행금액 = 0;
      for (const data of allData) {
        const content = data.postContents || {};

        // 총 예산
        const 총예산 = Number(content.body.total.계 || 0);
        const 집행금액 = Number(content.body.total.집행금액 || 0);
        const 집행률 = Number(content.body.total.집행률 || 0);
        const fieldName = data.field.field_name || '기타'

        if (countData[fieldName]) {
          countData[fieldName] += 집행률;
        } else {
          countData[fieldName] = 집행률;
        }
        총총예산 += 총예산;
        총집행금액 += 집행금액;
      }

      // 소수점 2째자리까지만 표시
      this.sumCount = Math.floor(총집행금액 / 총총예산 * 10000) / 100;

      const chartData = [];
      for (const key in countData) {
        chartData.push({label: key, value: countData[key]});
      }
      // value 값으로 내림차순 정렬한다
      chartData.sort((a, b) => b.value - a.value);

      this.chartData = chartData;
    }
  }
}
</script>

<style lang="scss" scoped>
.donut-chart-card {
  position: relative;

  .total {
    display: grid;
    justify-content: center;
    align-items: center;
    text-align: center;

    .total-value {
      font-size: 1.71em;
      font-weight: bold;
      color: #000
    }

    .total-unit {
      font-size: 1em;
      font-weight: bold;
      color: #757575
    }
  }
}

.donut-chart-card-header {
  display: flex;
  justify-content: space-between;
  align-items: start;

  position: absolute;
  top: -10px;
  left: 0;
  right: 0;
}

@media (max-width: 768px) {
  .donut-chart-card {
    margin: 0 6px !important;
    width: calc(100% - 12px);
  }
}
</style>
